import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { ProcessDesignHistory } from './process-design-history';
export { ProcessDesignHistory };
import { processDesignHistorySchema } from '@schemas/business-objects/process-design-history';
import { ProcessDesignFormGroup } from './process-design-form-group';
import { TenantFormGroup } from './tenant-form-group';

export class ProcessDesignHistoryFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    eventType: SchemaFormControl;
    data: SchemaFormControl;
    timestamp: SchemaFormControl;
    processDesignId: SchemaFormControl;
    processDesign: ProcessDesignFormGroup;
    tenantId: SchemaFormControl;
    tenant: TenantFormGroup;
  };

  declare value: Partial<ProcessDesignHistory>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(processDesignHistorySchema, ProcessDesignHistory, data, options);
  }

  get object(): ProcessDesignHistory {
    return new ProcessDesignHistory(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'processDesign':
        return new ProcessDesignFormGroup();
      case 'tenant':
        return new TenantFormGroup();
      default:
        return undefined;
    }
  }

  static async find(filter?: any): Promise<ProcessDesignHistory[]> {
    return ProcessDesignHistory.find(filter);
  }

  static async findOne(filter?: any): Promise<ProcessDesignHistory | null> {
    return ProcessDesignHistory.findOne(filter);
  }

  static async findById(
    id: string,
    filter?: any,
  ): Promise<ProcessDesignHistory> {
    return ProcessDesignHistory.findById(id, filter);
  }

  static async create(
    data: Partial<ProcessDesignHistory>,
  ): Promise<ProcessDesignHistory> {
    return ProcessDesignHistory.create(data as any);
  }

  static async updateById(
    id: string,
    updates: Partial<ProcessDesignHistory>,
  ): Promise<ProcessDesignHistory> {
    return ProcessDesignHistory.updateById(id, updates as any);
  }

  static async deleteById(id: string): Promise<boolean> {
    return ProcessDesignHistory.deleteById(id);
  }
}

export class ProcessDesignHistoryFormArray extends PersistedFormArray {
  declare controls: ProcessDesignHistoryFormGroup[];

  readonly entityName = 'ProcessDesignHistory' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(processDesignHistorySchema, ProcessDesignHistory, options);
  }

  protected override createItemGroup() {
    return new ProcessDesignHistoryFormGroup();
  }

  get array(): ProcessDesignHistory[] {
    return this.controls.map(
      (group: ProcessDesignHistoryFormGroup) => group.object,
    );
  }
}

export class ProcessDesignHistoryPersistedArray extends PersistedArray<ProcessDesignHistory> {
  readonly entityName = 'ProcessDesignHistory' as const;

  constructor(options?: PersistedArrayOptions) {
    super(ProcessDesignHistory, options);
  }
}
